import { makeStyles, MenuItem, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC, useState } from "react"
import Select from "../../atoms/Select"
import { ClientFragment } from "../../../generated/graphql"
import { colors } from "../../../utils/theme"
import { InsightsProps } from "../../../utils/types"
import UserInsightsTable from "../../molecules/UserInsightsTable"
import useOrganizationFeatureFlags from "../../../hooks/useOrganizationFeatureFlags"

const useStyles = makeStyles((theme) => ({
  charts: {
    display: "flex",
    flexDirection: "column",
  },
  chartContainer: {
    position: "relative",
    backgroundColor: `var(--vira-paper, ${colors.neutral.white})`,
    padding: theme.spacing(3),
    border: `1px solid var(--vira-border, ${colors.neutral.clay})`,
    borderRadius: 4,
  },
  firstChart: {
    marginRight: theme.spacing(2),
  },
  content: {
    marginBottom: theme.spacing(2),
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  header: {
    fontWeight: 400,
    color: "var(--vira-ink, #1E263C)",
  },
}))
enum TIME_PERIOD {
  WEEK = "week",
  MONTH = "month",
  HISTORY = "history",
}

const UserInsightFeed: FC<{
  client: ClientFragment
}> = ({ client }) => {
  const classes = useStyles()
  const [timePeriod, setTimePeriod] = useState<TIME_PERIOD>(TIME_PERIOD.WEEK)
  const handleTimePeriodChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setTimePeriod(e.target.value as TIME_PERIOD)
  }
  const { showMVP2Features } = useOrganizationFeatureFlags()

  return (
    <div className={classes.chartContainer}>
      <div className={classes.headerContainer}>
        <Typography
          variant="h5"
          component="h5"
          className={clsx(classes.header)}
        >
          {showMVP2Features
            ? "How to Improve Your Mood with Lifestyle Changes"
            : "Latest Insights"}
        </Typography>
        <Select value={timePeriod} onChange={handleTimePeriodChange}>
          <MenuItem value={TIME_PERIOD.WEEK}>
            {showMVP2Features ? "Past Week" : "Week"}
          </MenuItem>
          {showMVP2Features ? (
            <MenuItem value={TIME_PERIOD.MONTH}>Past Month</MenuItem>
          ) : (
            <MenuItem value={TIME_PERIOD.HISTORY}>History</MenuItem>
          )}
        </Select>
      </div>
      <UserInsightsTable client={client} timePeriod={timePeriod} />
    </div>
  )
}

const Insights: FC<InsightsProps> = ({ client }) => {
  return (
    <div>
      <UserInsightFeed client={client} />
    </div>
  )
}

export default Insights
